import React, { Component } from "react";
import { Wrapper, Row, Copy, Card } from "app/NativeComponents/common";

import PresetItem from "app/DealMachineCore/snippets/Presets/PresetItem";

class DealfinderHighlight extends Component {
  render() {
    if (this.props.dealfinder_filter) {
      return (
        <Wrapper style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Copy style={{ marginBottom: 10 }}>DealFinder highlight uses:</Copy>
          <Row style={{ flexWrap: "wrap", overflow: "visible" }}>
            <Card
              style={{
                margin: 0,
                marginBottom: 5,
                marginRight: 5,
                padding: 5,
                paddingLeft: 10,
                paddingRight: 10,
                borderRadius: 30
              }}
            >
              <Row>
                <Copy>{this.props.dealfinder_filter.title}</Copy>
              </Row>
            </Card>
          </Row>
        </Wrapper>
      );
    }
    return <Wrapper />;
  }
}

export default DealfinderHighlight;
